<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Trocas de Nível — Pendentes</h6>
        <i class="bi bi-x-circle close-icon" @click="$emit('fechar')" title="Fechar"></i>
      </div>

      <!-- Tabela -->
      <div class="table-container">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Matrícula</th>
              <th>Aluno</th>
              <th>Nível atual</th>
              <!-- <th>Novo nível</th> -->
              <th>Data solicitação</th>
              <th class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!registros || !registros.length">
              <td colspan="6" class="text-center">Nenhuma troca pendente.</td>
            </tr>

            <tr v-else v-for="r in registros" :key="r.supervisao_id">
              <td>{{ r.matricula_id ?? '-' }}</td>
              <td>{{ r.aluno_nome }}</td>
              <td>{{ r.nivel_atual ?? '-' }}</td>
              <!-- <td>{{ r.novo_nivel }}</td> -->
              <td>{{ formatarData(r.data_solicitacao) }}</td>
              <td class="text-center">
                <i
                  class="bi bi-arrow-right-circle action-icon"
                  title="Detalhar Matrícula"
                  :class="{ 'text-muted': !r.matricula_id }"
                  @click="detalhar(r.matricula_id)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Rodapé -->
      <!-- <div class="modal-footer">
        <button class="btn btn-outline-secondary btn-sm" @click="$emit('fechar')">
          Voltar / Cancelar
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import globalUtils from '@/utils/globalUtils.js';

export default {
  name: 'TrocarNivelTurma',
  props: {
    mostrar: { type: Boolean, default: false },
    registros: { type: Array, default: () => [] },
  },
  emits: ['fechar'],
  methods: {
    formatarData(d) {
      return d ? globalUtils.formatarData(d) : '-';
    },
    detalhar(matriculaId) {
      if (!matriculaId) return; // sem matrícula ativa: nada a detalhar
      this.$emit('fechar');
      this.$router.push({ name: 'DetalharMatriculas', params: { id: matriculaId } });
    }
  }
};
</script>

<style scoped>
/* mesmo padrão visual do PlanosAVencer */
.modal-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  display: flex; align-items: center; justify-content: center;
}
.modal-container {
  background: #fff;
  width: 100%; max-width: 760px;
  max-height: 80vh; overflow-y: auto;
  border-radius: 4px; z-index: 3001;
}
.modal-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 10px 15px; background: #f1f1f1; border-bottom: 1px solid #ddd;
}
.close-icon { font-size: 1.5rem; cursor: pointer; }
.table-container { padding: 15px; }
.table th, .table td { vertical-align: middle; }
.action-icon { cursor: pointer; font-size: 1.2rem; color: #007bff; }
.action-icon:hover { color: #0056b3; }
</style>
